import { cn } from '~/shadcn/lib/utils'

function TabTitleWrapper({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-row w-full justify-between px-10 pt-20 pb-6',
        className
      )}>
      {children}
    </div>
  )
}

export { TabTitleWrapper }
